var React = require('react');

function CropIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.crop-icon-svg{fill:#FAFAFA;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"crop-icon-svg","points":"9,7 10,7 10,3 10,2 9,2 4,2 4,3 9,3 \t","key":0}),React.createElement("polygon",{"className":"crop-icon-svg","points":"10,8 9,8 3,8 3,3 3,2 3,0 2,0 2,2 0,2 0,3 2,3 2,8 2,9 3,9 9,9 9,11 10,11 10,9 12,9 12,8 \t","key":1})])]);
}

CropIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 12 11","style":{"enableBackground":"new 0 0 12 11"},"xmlSpace":"preserve"};

module.exports = CropIcon;

CropIcon.default = CropIcon;
